import React from "react";
import { Button } from "@/components/ui/button";
import mockImg from "/mock1.png";
const DownloadApp = () => {
  return (
    <section
      className="py-12 sm:py-16 md:py-20 relative bg-white overflow-hidden"
      style={{
        backgroundColor: "white",
        backgroundImage: `
          radial-gradient(circle at 25% 25%, rgba(243, 244, 246, 0.6) 2px, transparent 2px),
          radial-gradient(circle at 75% 75%, rgba(243, 244, 246, 0.6) 2px, transparent 2px),
          linear-gradient(45deg, rgba(243, 244, 246, 0.3) 25%, transparent 25%, transparent 75%, rgba(243, 244, 246, 0.3) 75%),
          linear-gradient(-45deg, rgba(243, 244, 246, 0.3) 25%, transparent 25%, transparent 75%, rgba(243, 244, 246, 0.3) 75%)
        `,
        backgroundSize: "60px 60px, 60px 60px, 120px 120px, 120px 120px",
        backgroundPosition: "0 0, 30px 30px, 0 0, 60px 60px",
      }}
    >
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Content */}
            <div>
              <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-forest-green mb-4 sm:mb-6">
                Awaken Deep Rest with Yoga Nidra
              </h2>

              <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed mb-6 sm:mb-8 max-w-lg">
                Experience profound relaxation, conscious rest, and inner
                balance. Download the Cittasya® app to begin your journey
                inward.
              </p>

              {/* App Store Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-6 sm:mb-8">
                {/* App Store Button */}
                <button className="group relative overflow-hidden rounded-xl transition-all duration-300 hover:scale-105 shadow-xl hover:shadow-2xl w-full sm:w-auto">
                  <div className="bg-black text-white px-4 sm:px-6 py-2 sm:py-3 flex items-center gap-2 sm:gap-3 rounded-xl border border-gray-600 hover:border-gray-400 transition-all duration-300 justify-center sm:justify-start w-full">
                    <img
                      src="/apple.svg"
                      alt="Apple Logo"
                      className="w-8 sm:w-12 h-8 sm:h-12"
                    />
                    <div className="text-left">
                      <div className="text-xs text-gray-300">
                        Download on the
                      </div>
                      <div className="text-base sm:text-lg font-semibold leading-tight">
                        App Store
                      </div>
                    </div>
                  </div>
                </button>

                {/* Google Play Button */}
                <button className="group relative overflow-hidden rounded-xl transition-all duration-300 hover:scale-105 shadow-xl hover:shadow-2xl w-full sm:w-auto">
                  <div className="bg-black text-white px-4 sm:px-6 py-2 sm:py-3 flex items-center gap-2 sm:gap-3 rounded-xl border border-gray-600 hover:border-gray-400 transition-all duration-300 justify-center sm:justify-start w-full">
                    <img
                      src="/google-play.svg"
                      alt="Google Play Logo"
                      className="w-8 sm:w-12 h-8 sm:h-12"
                    />
                    <div className="text-left">
                      <div className="text-xs text-gray-300">GET IT ON</div>
                      <div className="text-base sm:text-lg font-semibold leading-tight">
                        Google Play
                      </div>
                    </div>
                  </div>
                </button>
              </div>

              {/* Features List */}
              {/* <div className="space-y-2 sm:space-y-3">
                {[
                  "Free guided sessions to start",
                  "Offline practice capability",
                  "Progress tracking & insights",
                  "Community support & wisdom",
                ].map((feature, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <div className="w-1.5 sm:w-2 h-1.5 sm:h-2 rounded-full bg-soft-saffron"></div>
                    <span className="text-sm sm:text-base text-gray-700">
                      {feature}
                    </span>
                  </div>
                ))}
              </div> */}
            </div>

            {/* App Preview */}
            <div className="flex justify-center lg:justify-end mt-8 lg:mt-0">
              <div className="relative w-full max-w-[280px] sm:max-w-[320px] md:max-w-[450px]">
                {/* Phone mockup */}
                <img src={mockImg} />

                {/* Floating elements */}
                <div className="absolute -top-4 -right-4 w-12 sm:w-16 h-12 sm:h-16 rounded-full bg-gradient-to-br from-soft-saffron to-copper-brown animate-pulse shadow-lg"></div>
                <div className="absolute -bottom-8 -left-4 w-8 sm:w-12 h-8 sm:h-12 rounded-full bg-gradient-to-br from-misty-sage to-sand-beige animate-pulse delay-1000 shadow-lg"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadApp;
